import type { ButtonHTMLAttributes } from "react";

type Variant = "amber" | "ghost";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
}

const base =
  "inline-flex items-center justify-center rounded-lg px-4 py-2 text-sm font-extrabold transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent disabled:opacity-60";

const variants: Record<Variant, string> = {
  amber: "bg-accent text-accent-ink hover:bg-accent-strong",
  ghost: "border border-line text-ink hover:bg-surface-2",
};

export function Button({ variant = "amber", className = "", ...props }: Props) {
  return <button className={`${base} ${variants[variant]} ${className}`} {...props} />;
}
